import {warning, semiDarkGray, lightGray, mediumGray} from '@modifi/colors'
import {AddIcon, Col, Row, media, SkeletonLine} from '@modifi/ui'
import styled from 'styled-components'

export const FormContentWrapper = styled.div`
  min-height: 45vh;
`

type WarningColType = {
  alertColor?: string
}

export const WarningCol = styled(Col)<WarningColType>`
  margin-top: -32px;
  margin-bottom: 8px;
  color: ${({alertColor}): string => alertColor || warning};
`

export const CompanyNameNoOptionWrapper = styled(Row)`
  margin: 0;
  margin-bottom: 24px;
  ${media.md`
    margin: 0 12px 24px 2px;
  `}
`

export const CompanyNameNoOptionLabel = styled(Col)`
  padding: 0;
`

export const CompanyNameNoOptionInput = styled(Col)`
  padding: 10px 16px;
  color: ${semiDarkGray};
  background-color: rgb(242, 242, 242);
  border-radius: 8px;
`

export const StyledAddIcon = styled(AddIcon)`
  margin-right: 8px !important;
  margin-left: -4px;
  margin-bottom: 1px;
`

export const StyledSkeletonLine = styled(SkeletonLine)`
  border-radius: 2px;
  background-image: linear-gradient(-90deg, ${lightGray} 0%, ${mediumGray} 50%, ${lightGray} 100%);
`
